/**
 * McCarthy Motors Midleton - Business Configuration
 * Single source of truth for all dealership information
 */

// ============================================================
// LOGO CONFIGURATION
// ============================================================
// Primary logo for dark backgrounds (McCarthy Motors transparent PNG)
export const LOGO_PRIMARY = 'https://customer-assets.emergentagent.com/job_cardealer-template/artifacts/jvdr2nvx_mccarthy%20motors%20transparent%20background.png';

// Alternative logo for light backgrounds (if needed in future)
export const LOGO_LIGHT_BG = 'https://customer-assets.emergentagent.com/job_cardealer-template/artifacts/ibq4o6g7_mcm%20transparent%20for%20white%20background.png';

// Default export for backwards compatibility
export const LOGO_URL = LOGO_PRIMARY;

// Logo sizing configuration (in pixels)
export const LOGO_SIZES = {
  header: {
    mobile: 48,    // h-12
    desktop: 56,   // h-14
  },
  footer: 48,      // h-12
  dashboard: 64,   // h-16
};

// ============================================================
// BUSINESS INFORMATION
// ============================================================
export const DEALERSHIP_INFO = {
  // Business Identity
  name: 'McCarthy Motors Midleton',
  shortName: 'McCarthy Motors',
  tagline: 'Your Trusted Motor Car Service & Repair Centre',
  description: 'Premium pre-owned vehicles and expert automotive service in Midleton, Co. Cork',
  
  // Contact Information
  phone: '086 873 9413',
  phoneHref: 'tel:+353868739413',
  email: 'mccarthycarsales91@gmail.com',
  emailHref: 'mailto:mccarthycarsales91@gmail.com',
  
  // Location
  address: {
    line1: 'Oatencake',
    line2: 'Midleton',
    city: 'Co. Cork',
    postcode: 'P25 KX61',
    country: 'Ireland',
    full: 'Oatencake, Midleton, Co. Cork, P25 KX61'
  },
  
  // Google Maps
  mapUrl: 'https://www.google.com/maps/search/?api=1&query=McCarthy+Motors+Midleton',
  
  // Opening Hours
  hours: {
    monday: '9:00am – 6:00pm',
    tuesday: '9:00am – 6:00pm',
    wednesday: '9:00am – 6:00pm',
    thursday: '9:00am – 6:00pm',
    friday: '9:00am – 6:00pm',
    saturday: 'Closed',
    sunday: 'Closed'
  },
  
  hoursFormatted: [
    { day: 'Monday', time: '9:00am – 6:00pm', open: true },
    { day: 'Tuesday', time: '9:00am – 6:00pm', open: true },
    { day: 'Wednesday', time: '9:00am – 6:00pm', open: true },
    { day: 'Thursday', time: '9:00am – 6:00pm', open: true },
    { day: 'Friday', time: '9:00am – 6:00pm', open: true },
    { day: 'Saturday', time: 'Closed', open: false },
    { day: 'Sunday', time: 'Closed', open: false }
  ],
  
  hoursSummary: 'Mon–Fri: 9am–6pm',
  
  // Legal
  copyrightYear: new Date().getFullYear(),
  copyright: `© ${new Date().getFullYear()} McCarthy Motors Midleton. All rights reserved.`
};

// Finance Disclaimer
export const FINANCE_DISCLAIMER = 'Finance figures are indicative only and subject to approval. Final monthly payments, interest rates, and terms may vary.';

// Trust Badges / Selling Points
export const TRUST_POINTS = [
  { title: 'Quality Assured', description: 'Every vehicle thoroughly inspected' },
  { title: 'Fair Pricing', description: 'Transparent, competitive prices' },
  { title: 'Expert Service', description: 'Professional maintenance & repairs' },
  { title: 'Local Trust', description: 'Serving Cork since establishment' }
];

export default DEALERSHIP_INFO;
